import {Injectable} from '@angular/core';
import {NeoRestService} from '../neo-rest/neo-rest.service';
import {Observable} from "rxjs/Rx";

@Injectable()
export class NeoTranslationService {

    constructor(
        private _rest: NeoRestService
    ) {}

    /**
     * Obtiene las tranducciones
     *
     * @param site
     */
    getTranslations(site) {
        return this._rest.get(`/translations/${site}`);
    }

    /**
     * Obtiene las tranducciones genericas
     *
     * @param site
     * @param translation
     */
    updateOrCreateLabel(site, translation): Observable<any> {
        return this._rest.postRaw(`/translations/${site}`, {translation});
    }

    /**
     * Elimina las traducciones de un label
     *
     * @param site
     * @param translation
     * @returns {Observable<any>}
     */
    deleteLabel(site, translation): Observable<any> {

        return this._rest.postRaw(`/translations/${site}/delete`, {translation});
    }

    /**
     * Obtiene una traduccion a partir de google translate
     *
     * @param target
     * @param text
     * @returns {Observable<any>}
     */
    getTranslationFromGoogle(target, text) {
        return this._rest.get(`/google/translate?target=${target}&text=${text}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-translations/neo-translations.service.ts